import { Component, OnInit, Input, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { IInsightItem, IInsightItemAttachment, InsightKind } from '../../models/IGlimpseReport';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import dayjs from "dayjs";

@Component({
    selector: 'app-insight-card',
    templateUrl: './insight-card.component.html',
    styleUrls: ['./insight-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class InsightCardComponent implements OnInit {
  @Input() item: IInsightItem;
  @Input() admin = false;
  @Input() loading = false;
  @Input() showMistakes = false;
  @Input() adjustedChanges: { name: string; oldValue: string; value: string }[];
  @Input() periodId: string;
  @Input() locationId: number;

  @Output() edit = new EventEmitter();
  @Output() delete = new EventEmitter();
  @Output() addAttachment = new EventEmitter();
  @Output() editAttachment = new EventEmitter<IInsightItemAttachment>();
  @Output() removeAttachment = new EventEmitter<IInsightItemAttachment>();
  @Output() reelClick = new EventEmitter<IInsightItemAttachment>();
  @Output() regenerate = new EventEmitter();

  compareMode = false;
  startDate: string;
  endDate: string;

  get itemText() {
    return this.translateText(this.item.text);
  }

  constructor(private translate: TranslateService) {}

  ngOnInit() {
    this.startDate = dayjs(this.periodId).format('YYYY-MM-DD');
    this.endDate = dayjs(this.periodId).add(1, 'month').add(-1, 'day').format('YYYY-MM-DD');
  }

  oldValue(param: string): string {
    return this.adjustedChanges.find(x => x.name === param)?.oldValue ?? '--- Empty ---';
  }

  compare() {
    this.compareMode = !this.compareMode;
  }

  translateText(text: string): Observable<string> {
    if (!text) return of(text);

    const firstChar = text.substring(0, 2);

    // Check if the text starts with an emoji using Unicode properties
    if (/\p{Emoji}/u.test(firstChar)) {
      const emoji = firstChar;
      const remainingText = text.substring(2).trimStart();
      return this.translate.get(remainingText).pipe(
        map((translation: string) => {
          return emoji + ' ' + translation;
        }),
      );
    } else return of(text);
  }

  public readonly InsightKind = InsightKind;
}
